import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../_shared/services/user.service';
import { Jwt } from '../_shared/models/jwt.model';
import { JwtService } from '../_shared/services/jwt.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit, OnDestroy {

  public signinForm: FormGroup;
  public isLoading: boolean = false;
  private pattern = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,15})");
  private subscription?: Subscription;

  constructor(private _fb: FormBuilder, private _router: Router, private _userService: UserService,
    private _jwtService: JwtService) {
    this.signinForm = this._fb.group({
      'email': [null, Validators.compose([Validators.required, Validators.email, Validators.maxLength(50)])],
      'password': ['', Validators.compose([Validators.required, Validators.pattern(this.pattern), Validators.maxLength(50)])]
    });
   }

  ngOnInit(): void {
  }

  public signin(form: any) {
    this.isLoading = true;
    this.subscription = this._userService.signin(form.email, form.password).subscribe((response: Jwt) => {
      this._jwtService._base64Token = response.access_token;
      if(this._userService.isRegionalManager || this._userService.isReporter) {
        this._router.navigate(['/dashboard']);
      } else if(this._userService.isAdmin) { 
        this._router.navigate(['/users']);
      } else {
        this._router.navigate(['/support']);
      }
      this.isLoading = false;
    }, () => this.isLoading = false);
  }

  ngOnDestroy(): void {
    if (this.subscription && !this.subscription.closed)
      this.subscription.unsubscribe();    
  }

  public isInValid(input: string, error: string): boolean {
    return this.signinForm.controls[input].hasError(error);
  }
  public isTouched(input: string): boolean {
    return this.signinForm.controls[input].touched;
  }
  public get isEmailInvalid(): boolean {
    return this.isInValid('email', 'required') && this.isTouched('email')
  }
  public get isEmailPatternInvalid(): boolean {
    return this.isInValid('email', 'email') && this.isTouched('email')
  }
  public get isEmailLengthInvalid(): boolean {
    return this.isInValid('email', 'maxlength') && this.isTouched('email')
  }
  public get isPasswordInvalid(): boolean {
    return this.isInValid('password', 'required') && this.isTouched('password')
  }
  public get isPasswordPatternInvalid(): boolean {
    return this.isInValid('password', 'pattern') && this.isTouched('password')
  }
  public get isPasswordLengthInvalid(): boolean {
    return this.isInValid('password', 'maxlength') && this.isTouched('password')
  }

}
